// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import trackEventAJAX from '@ta/common.tracking';
import type { PointOfSale } from './types';
import styles from './PosListItem.less';

type ExternalProps = {|
  pos: PointOfSale,
  currentLocale: string,
|};

type Props = {|
  ...ExternalProps,
  cookieDomain: string,
|};

const PosListItem = (props: Props) => {
  const clickHandler = (pos: PointOfSale) => {
    const trackProps = {
      module: 'POS_PICKER',
      action: 'SELECT',
      context: `${pos.locale}_FROM_${props.currentLocale}`,
    };
    // TODO: We need a way to track an event before moving to a new domain.
    // There is a chance this AJAX call will fail before switching pages/domains.
    // A synchronous ajax call may be the only way.
    trackEventAJAX(trackProps);
    Cookies.remove('TAPD', { path: '/', domain: props.cookieDomain });
  };

  return (
    <li
      className={`${styles.posItem} ${props.pos.isCurrentPointOfSale ? styles.selected : ''}`}
      ref={el => {
        if (el && props.pos.isCurrentPointOfSale) {
          el.scrollIntoView();
        }
      }}
    >
      <a
        className={`${styles.posLink} ui_link`}
        hrefLang={props.pos.headerContentLanguage}
        title={props.pos.countryInLang}
        href={props.pos.url}
        onClick={() => clickHandler(props.pos)}
      >
        <span>{props.pos.country}</span>
      </a>
    </li>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  cookieDomain: state.tracking.cookieDomain,
}))(PosListItem);
